import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "./DraggableButton.css";
import { ogip,baseURL } from "../constants";

const DraggableButton = ({ onOptionClick, locationresponsedata }) => {
    const [position, setPosition] = useState({ x: 120, y: 60 });
    const [isDragging, setIsDragging] = useState(false);
    const [isDropdownVisible, setDropdownVisible] = useState(false);

    const dragStartRef = useRef({ x: 0, y: 0 });
    const initialMousePosRef = useRef({ x: 0, y: 1000 });

    const TAP_THRESHOLD = 10; // Max distance for a tap to be recognized
    const dropdownRef = useRef(null); // Ref for the dropdown
    const busiconlist = {};

    locationresponsedata.forEach((index) => {
        const ogbusico = require("./markers/bus_markerog.png");
        const busico = index.marker_pic_url; // This should already contain the full URL
        if (busico === "./markers/bus_markerog.png") {
            busiconlist[index.device_name] = ogbusico;
        }
        else if (busico === null) {
            busiconlist[index.device_name] = ogbusico;
        }
        else {
            busiconlist[index.device_name] = busico;
        }});
        
    const startDrag = (x, y) => {
        initialMousePosRef.current = { x, y };
        dragStartRef.current = { x: x - position.x, y: y - position.y };
        setIsDragging(false);
    };

    const handleMove = (x, y) => {
        const newX = x - dragStartRef.current.x;
        const newY = y - dragStartRef.current.y;
        const distanceMoved = Math.sqrt(
            Math.pow(x - initialMousePosRef.current.x, 2) +
            Math.pow(y - initialMousePosRef.current.y, 2)
        );

        if (distanceMoved > TAP_THRESHOLD) {
            setIsDragging(true);
            setPosition({ x: newX, y: newY });
        }
    };

    const endDrag = (x, y) => {
        const distanceMoved = Math.sqrt(
            Math.pow(x - initialMousePosRef.current.x, 2) +
            Math.pow(y - initialMousePosRef.current.y, 2)
        );

        if (distanceMoved <= TAP_THRESHOLD && !isDragging) {
            setDropdownVisible((prev) => !prev); // Toggle dropdown only on a tap
        }
        setIsDragging(false);
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
        startDrag(e.clientX, e.clientY);

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };

    const handleMouseMove = (e) => {
        e.preventDefault();
        handleMove(e.clientX, e.clientY);
    };

    const handleMouseUp = (e) => {
        e.preventDefault();
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        endDrag(e.clientX, e.clientY);
    };

    const handleTouchStart = (e) => {
        const touch = e.touches[0];
        startDrag(touch.clientX, touch.clientY);

        document.addEventListener("touchmove", handleTouchMove, { passive: false });
        document.addEventListener("touchend", handleTouchEnd);
    };

    const handleTouchMove = (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        handleMove(touch.clientX, touch.clientY);
    };

    const handleTouchEnd = (e) => {
        const touch = e.changedTouches[0];
        document.removeEventListener("touchmove", handleTouchMove);
        document.removeEventListener("touchend", handleTouchEnd);
        endDrag(touch.clientX, touch.clientY);
    };

    const handleOptionClick = (option) => {
        onOptionClick(option);
        setDropdownVisible(false);
    };

    const handleOutsideClick = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setDropdownVisible(false); // Close dropdown when clicking outside
        }
    };

    useEffect(() => {
        if (isDropdownVisible) {
            document.addEventListener("mousedown", handleOutsideClick);
            document.addEventListener("touchstart", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
            document.removeEventListener("touchstart", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
            document.removeEventListener("touchstart", handleOutsideClick);
        };
    }, [isDropdownVisible]);

    return ReactDOM.createPortal(
        <div
            style={{
                position: "fixed",
                bottom: window.innerWidth < 600 ? window.innerHeight * 0.3 : window.innerHeight * 0.25,
                right: window.innerWidth < 600 ? window.innerWidth * 0.53 : window.innerWidth * 0.15,
                width: "fit-content",
                height: "fit-content",
                zIndex: 1000,
            }}
        >
            <button
                className="draggable-button"
                style={{
                    position: "absolute",
                    top: position.y,
                    left: position.x,
                    cursor: isDragging ? "grabbing" : "pointer",
                    zIndex: 1001,
                    padding: 0,
                }}
                title="Select a Bus"
                onMouseDown={handleMouseDown}
                onTouchStart={handleTouchStart}
            >
                <img src={require("./markers/bus_mark.png")} alt="bus" style={{ width: "75px", height: "75px", padding: "0" }} />
            </button>

            {isDropdownVisible && (
                <div
                    ref={dropdownRef}
                    className="dropdown-menu"
                    style={{
                        position: "absolute",
                        top: position.y - 160 ,
                        left: position.x - 130,
                        border: "1px solid #ccc",
                        borderRadius: "30px",
                        padding: "10px",
                        zIndex: 2000,
                        minWidth: "220px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "white",
                        display: "block",
                        height:'150px',
                        overflowY:'auto'
                    }}
                >
                    <ul>
                        {locationresponsedata.map((element) => (
                            element.device_name.toLowerCase().includes("test") || <li key={element.device_name} onClick={() => handleOptionClick(element.device)}>
                                <img
                                    src={busiconlist[element.device_name].replace(ogip, baseURL)}
                                    alt="bus"
                                    style={{ width: "40px", height: "60px", padding: "0", marginRight: "10px" }}
                                />
                                {element.device_name.replace("Bus", "").replace("bus", "").replaceAll("-", "")}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>,
        document.body
    );
};

export default DraggableButton;